import { $ } from "@/common/Axios";

export default {
  /**
   * ai网络资源数据
   */
  baseNetClueData_exportForAdult: {
    /*
     * 成人学历列表导出
     */
    get: (p, c) => $.get("/api/bms/ai/baseNetClueData/exportForAdult", p, c),
  },
  baseNetClueData_exportForContinue: {
    /*
     * 全日制列表导出
     */
    get: (p, c) => $.get("/api/bms/ai/baseNetClueData/exportForContinue", p, c),
  },
  baseNetClueData_listForAdult: {
    /*
     * 成人学历列表
     */
    get: (p, c) => $.get("/api/bms/ai/baseNetClueData/listForAdult", p, c),
  },
  baseNetClueData_listForContinue: {
    /*
     * 全日制列表
     */
    get: (p, c) => $.get("/api/bms/ai/baseNetClueData/listForContinue", p, c),
  },
  baseNetClueData_refresh: {
    /*
     * 刷新数据
     * startTime 开始时间 (string query )
     */
    put: (p, c) => $.put("/api/bms/ai/baseNetClueData/refresh", p, c),
  },
  baseNetClueData_refreshContract: {
    /*
     * 刷新合同数据
     * startTime 开始时间 (string query )
     */
    put: (p, c) => $.put("/api/bms/ai/baseNetClueData/refreshContract", p, c),
  },

  /**
   * ai网络合同数据
   */
  baseNetContractData_exportContinue: {
    /*
     * 职教合同列表导出
     */
    get: (p, c) =>
      $.get("/api/bms/ai/baseNetContractData/exportContinue", p, c),
  },
  baseNetContractData_exportForAdult: {
    /*
     * 成人学历列表导出
     */
    get: (p, c) =>
      $.get("/api/bms/ai/baseNetContractData/exportForAdult", p, c),
  },
  baseNetContractData_exportForContinue: {
    /*
     * 全日制列表导出
     */
    get: (p, c) =>
      $.get("/api/bms/ai/baseNetContractData/exportForContinue", p, c),
  },
  baseNetContractData_listContinue: {
    /*
     * 职教合同列表
     */
    get: (p, c) => $.get("/api/bms/ai/baseNetContractData/listContinue", p, c),
  },
  baseNetContractData_listForAdult: {
    /*
     * 成人学历列表
     */
    get: (p, c) => $.get("/api/bms/ai/baseNetContractData/listForAdult", p, c),
  },
  baseNetContractData_listForContinue: {
    /*
     * 全日制列表
     */
    get: (p, c) =>
      $.get("/api/bms/ai/baseNetContractData/listForContinue", p, c),
  },
};
